import { render, staticRenderFns } from "./reisen-metadata-card-inlandsfluege.vue?vue&type=template&id=143ff64a&scoped=true"
import script from "./reisen-metadata-card-inlandsfluege.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-inlandsfluege.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-inlandsfluege.vue?vue&type=style&index=0&id=143ff64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ff64a",
  null
  
)

export default component.exports